<template>
  <div class="section footer py-4 font-boring bg-black text-white ">

 
        

    <div class="container margin-center">

      <div class=" grid grid-flow-col ">
        <div class=" grid grid-flow-row text-center px-4">

          <img src="@/assets/images/copyright_mfer.png" width="70%" />
          
         

          </div>

        <div class=" grid grid-flow-row text-center px-4">

          <h3 class="text-lg font-bold font-fun ">Community &amp; Social</h3>

            <a href="https://discord.apexmfer.com" target="_blank" class="footer-link">Discord</a>
         
            <a href="https://youtube.apexmfer.com" target="_blank" class="footer-link">Youtube</a>

           
          

         </div>
      </div>
    </div>
  </div>
</template>


<script>


export default {
  name: 'Footer',
  props: [],
  data() {
    return {

    }
  },
  created(){

  },
  methods: {

  }
}
</script>
